import React__default from 'react';
import { DateField, Label, DateInput as DateInput$1, DateSegment, FieldError } from 'react-aria-components';
import { WarningIcon } from '../icons/WarningIcon.js';
import { Button } from './Button.js';
import { XIcon } from './TextInput.js';
import './DateInput.scss';

const DateInput = (props) => {
    const { label, isRequired, variant = 'outline', size = 'large', rounding = '10', isClearable = true, isDisabled, isReadOnly, hasError, ...reactAriaDateFieldProps } = props;
    const showInvalidState = !!hasError;
    const showClearButton = isClearable && props.value && !isDisabled && !isReadOnly;
    return (React__default.createElement(DateField, { ...reactAriaDateFieldProps, "aria-invalid": showInvalidState, isInvalid: showInvalidState, isDisabled: isDisabled || isReadOnly, "data-rev-component": 'date-input', shouldForceLeadingZeros: true },
        label && (React__default.createElement(Label, { className: 'date-input-label--rev', "data-invalid": !!hasError },
            label,
            isRequired && React__default.createElement("span", { className: 'date-input-required--rev' }, "(required)"))),
        React__default.createElement("div", { className: 'date-input-group--rev', "data-rev-variant": variant, "data-rev-size": size, "data-rev-rounding": rounding, "data-disabled": isDisabled || isReadOnly, "data-invalid": !!hasError },
            React__default.createElement(DateInput$1, { className: 'date-input-guts--rev' }, (segment) => (React__default.createElement(DateSegment, { className: 'date-input-spinner--rev', segment: segment }))),
            showClearButton && (React__default.createElement(Button, { className: 'date-input-side-button--rev', "aria-label": 'Clear', variant: 'ghost', onPress: () => props.onChange?.(null) },
                React__default.createElement(XIcon, null)))),
        hasError && typeof hasError === 'string' && (React__default.createElement(FieldError, { className: 'date-input-error--rev' },
            React__default.createElement(WarningIcon, null),
            hasError))));
};
DateInput.displayName = 'DateInput';

export { DateInput };
//# sourceMappingURL=DateInput.js.map
